module.exports = __webpack_public_path__ + "src/img/avatar-g.bc5e7325.png";